import { isKharonV2Allowed } from '@retracedgmbh/modules';
import { useAuth } from '@/state/auth';

export function useCanAccessKharonV2(): boolean {
  const me = useAuth(state => state.me);
  const switchedCompanyId = useAuth(state => state.companyId);
  const effectiveCompanyId = switchedCompanyId || me?.company?.id;
  return isKharonV2Allowed(effectiveCompanyId, me?.id);
}
